import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "partner-picker-search"
}
const _hoisted_4 = { class: "partner-picker-results" }
const _hoisted_5 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["partner-picker", { editing: $setup.editing }])
  }, [
    (!$setup.editing)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "inline-field",
          tabindex: "0",
          onClick: $setup.begin,
          onKeydown: _withKeys(_withModifiers($setup.begin, ["prevent"]), ["enter"])
        }, [
          _createElementVNode("span", null, _toDisplayString($setup.current?.name || $props.placeholder), 1 /* TEXT */),
          ($setup.current?.primary_email)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString($setup.current.primary_email), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
            placeholder: "Название или email",
            onInput: $setup.search,
            onKeydown: _cache[1] || (_cache[1] = _withKeys($event => ($setup.editing=false), ["esc"]))
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelText, $setup.query]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = $event => ($setup.choose(null)))
            }, [
              _createElementVNode("strong", null, _toDisplayString($props.placeholder), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (partner) => {
              return (_openBlock(), _createElementBlock("button", {
                key: partner.id,
                type: "button",
                onClick: $event => ($setup.choose(partner))
              }, [
                _createElementVNode("strong", null, _toDisplayString(partner.name), 1 /* TEXT */),
                _createElementVNode("small", null, _toDisplayString(partner.primary_email || 'Без email') + " · " + _toDisplayString(partner.category?.name || 'Без категории'), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
  ], 2 /* CLASS */))
}